module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.titleText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12a8a8eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/title-text.vue
// module id = 825
// module chunks = 34